export default class extends Controller {
  static targets = ["link", "statusSelect", "statusLabel"];

  connect() {
    this.updateStatus = this.updateStatus.bind(this)
    App.DynamicSelect.initEl(this.statusSelectTarget)
    App.DynamicSelect.onChange(this.statusSelectTarget, this.updateStatus);
  }

  updateStatus() {
    this.linkTarget.href = this.data.get("base-url").replace(/STATUS/g, this.currentStatus)
  }

  //
  // GETTERS AND SETTERS
  //

  get currentStatus() {
    return App.DynamicSelect.getValue(this.statusSelectTarget)
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/data_exports/data-exports-projects-link-controller.js